import React from 'react';
import { isExpired } from 'react-jwt';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import type { ROLE } from '../../../enums';
import { selectIsAuthenticated, selectToken, selectUser } from '../../../store/reducers';

type ProtectedPageProps = {
  children: React.ReactElement;
  roles?: ROLE[];
};

export function ProtectedPage({ children, roles }: ProtectedPageProps): React.JSX.Element {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const user = useSelector(selectUser);
  const token = useSelector(selectToken);
  const location = useLocation();

  if (!isAuthenticated || !token || isExpired(token)) {
    return <Navigate to='/login' state={{ from: location }} replace />;
  }

  if (roles !== undefined && user && !roles.includes(user.role)) {
    return <Navigate to='/dashboard' />;
  }

  return children;
}
